import type { IconData } from '@stacksjs/iconify-core'

export const tablet: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M440 16H80a24.03 24.03 0 0 0-24 24v432a24.03 24.03 0 0 0 24 24h360a24.03 24.03 0 0 0 24-24V40a24.03 24.03 0 0 0-24-24m-8 448H88v-96h344Zm0-128H88V48h344Z\"/><path fill=\"currentColor\" d=\"M232 400h32v32h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default tablet
